import { Box, Button, Progress, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react"
import { ChevronLeftIcon, ArrowForwardIcon } from '@chakra-ui/icons'
import { ReactComponent as Clock } from '../../svg/clock.svg'
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { calculateTimeTakenForQuestion, convertToMinutes, quizStarted, quizSubmitted, resetAnswerState, setAutocompleteVisibility, setHeaderText, setSelectedMenuItem } from "../../redux/actions/action"
import QuizCompletion from "./QuizCompletion"
import { answerQuestion } from "../../redux/api/apiCalls"
let intervalId

export default function Questions() {
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [radioButton, setRadioButton] = useState(null)
    const [minutes, setMinutes] = useState(null)
    const [seconds, setSeconds] = useState(null)
    const { questions, isLoading } = useSelector(state => state.quizQuestionsState)
    const { quizInProgress, quizCompleted, playAgain } = useSelector(state => state.quizProgressState)
    const { isAnswering, answerSubmitSuccess } = useSelector(state => state.answerState)
    const [questionStartTime, setQuestionStartTime] = useState(null)
    const dispatch = useDispatch()

    const nextQuestionHandler = () => {
        let timeTaken = questions.time_duration ?
            calculateTimeTakenForQuestion(Date.now() - questionStartTime) :
            ((minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds))

        let answerObject = {
            "quiz_id": questions.id,
            "question_id": questions.question[currentQuestion].id,
            "answer_id": questions.question[currentQuestion].choices.find(choice => choice.choice === radioButton).id,
            "taken_time": timeTaken,
            "course_id": Number(questions.course_id),
            "topic_id": questions.topic_id ? Number(questions.topic_id) : null,
        }
        if (currentQuestion === 0) {
            answerObject["quiz_start"] = 'Y'
        }
        if (currentQuestion === questions.question.length - 1) {
            answerObject["quiz_end"] = "Y"
        }
        console.log(answerObject)
        dispatch(answerQuestion(answerObject))
    }

    useEffect(() => {
        if (questions) {
            setMinutes(questions.time_duration ? convertToMinutes(questions.time_duration) : 0)
            setSeconds(0)
        }
        // eslint-disable-next-line
    }, [questions])

    useEffect(() => {
        if (answerSubmitSuccess) {
            if (currentQuestion < questions?.question.length - 1) {
                setCurrentQuestion(currentQuestion + 1)
                setRadioButton(null)
                dispatch(resetAnswerState())
                if (questions.time_duration) {
                    setQuestionStartTime(Date.now())
                }
                else {
                    setMinutes(0)
                    setSeconds(0)
                }
            }
            else {
                dispatch(quizSubmitted())
                dispatch(resetAnswerState())
            }
        }
        // eslint-disable-next-line
    }, [answerSubmitSuccess])

    useEffect(() => {
        intervalId = setInterval(() => {
            if (questions.time_duration) {
                if (seconds === 0) {
                    if (minutes === 0) {
                        clearInterval(intervalId);
                    } else {
                        setSeconds(59);
                        setMinutes(minutes - 1);
                    }
                }
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                }
            }
            else {
                if (seconds === 59) {
                    setSeconds(0);
                    setMinutes(minutes + 1);
                }
                else {
                    setSeconds(seconds + 1);
                }
            }
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
        // eslint-disable-next-line
    }, [minutes, seconds])

    useEffect(() => {
        dispatch(setHeaderText('Quizzes'))
        dispatch(setSelectedMenuItem(2))
        setQuestionStartTime(Date.now())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (playAgain) {
            dispatch(quizStarted())
            setQuestionStartTime(Date.now())
            setMinutes(0)
            setSeconds(0)
            setCurrentQuestion(0)
            setRadioButton(null)
        }
        // eslint-disable-next-line
    }, [playAgain])

    return (
        <>
            {
                isLoading && <Progress size='xs' isIndeterminate width='100%' />
            }
            {!isLoading && quizInProgress && !quizCompleted &&
                < Box
                    px='1rem'
                    w={['100%', '100%', '95%', '80%']}
                    minH='90vh'
                    pt='2rem'
                    position='relative'
                    onClick={(e) => {
                        e.stopPropagation()
                        dispatch(setAutocompleteVisibility(false))
                    }}
                >
                    <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                    >
                        <Box
                            d='flex'
                            justifyContent='center'
                            alignItems='center'
                            cursor='pointer'
                        >
                            <ChevronLeftIcon width='28px' height='28px' />
                            <Text
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='16px'
                                fontWeight='600'
                                color='#010101'
                            >
                                Back
                            </Text>
                        </Box>

                        <Box
                            d='flex'
                            justifyContent='center'
                            alignItems='center'
                            boxShadow='0px 2px 6px rgba(0, 0, 0, 0.15)'
                            borderRadius='30px'
                            padding='11px 20px'
                            bg='#ffffff'
                        >
                            <Clock />
                            <Text
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize={['16px', '16px', '16px', '20px']}
                                fontWeight='800'
                                color='#DA8726'
                                ml='1rem'
                            >
                                {minutes < 10 ? '0' + minutes : minutes}:{seconds < 10 ? '0' + seconds : seconds}
                            </Text>
                        </Box>
                    </Box>
                    <Box
                        w='100%'
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        flexDir='column'
                        position={['static', 'static', 'static', 'absolute']}
                        top='0'
                    >
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize='45px'
                            fontWeight='900'
                            color='#000000'
                            pt='2rem'
                        >
                            {questions.title}
                        </Text>
                        <Box
                            bg='#f2f2f2'
                            p='11px 20px'
                            borderRadius='8px'
                            mt='1rem'
                            mb='1.5rem'
                        >
                            <Text
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='16px'
                                fontWeight='700'
                                color='#3e59de'
                                textTransform='uppercase'
                            >
                                Question {currentQuestion + 1}/{questions.question?.length}
                            </Text>
                        </Box>
                        <Box
                            w={['95%', '95%', '90%', '75%']}
                            d='flex'
                            flexDir='column'
                            justifyContent='flex-start'
                            alignItems='flex-start'
                        >
                            <Text
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='24px'
                                fontWeight='600'
                                color='#333333'
                                px='1rem'
                                mb='1rem'
                            >
                                Q. {questions?.question[currentQuestion]?.question || 'N/A'}
                            </Text>
                            <RadioGroup
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='16px'
                                onChange={setRadioButton}
                                value={radioButton || -1}
                                w='100%'
                            >
                                <Stack direction="column">
                                    {
                                        questions?.question[currentQuestion]?.choices.map((choice, idx) => <Box
                                            key={idx}
                                            alignItems='center'
                                            justifyContent='flex-start'
                                            d='flex'
                                            bg={radioButton === choice.choice ? '#3E59DE1A' : '#fcfcfc'}
                                            borderRadius='10px'
                                            border='1px solid rgba(0, 0, 0, 0.1)'
                                            width='100%'
                                            py='3'
                                            px='2'
                                        >
                                            <Radio
                                                value={choice.choice}
                                                color='#333333CC'
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                fontSize='20px'
                                                fontWeight='600'
                                            >
                                                {choice.choice}
                                            </Radio>
                                        </Box>
                                        )
                                    }
                                </Stack>
                            </RadioGroup>
                        </Box>
                        <Box
                            w={['95%', '95%', '95%', '75%']}
                            d='flex'
                            justifyContent='flex-end'
                            alignItems='center'
                            mt='2rem'
                        >
                            <Button
                                bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                                borderRadius='7px'
                                py={['16px', '16px', '16px', '24px']}
                                px={['26px', '28px', '38px', '31px']}
                                boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                                d='flex'
                                justifyContent='center'
                                alignItems='center'
                                textTransform='uppercase'
                                style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                                _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                                fontSize={['18px', '18px', '18px', '22px']}
                                fontWeight='800'
                                color='#FFFFFF'
                                disabled={!radioButton}
                                isLoading={isAnswering}
                                loadingText='Submitting...'
                                onClick={nextQuestionHandler}
                            >
                                {
                                    currentQuestion < questions?.question?.length - 1 ?
                                        <>Next Question < ArrowForwardIcon width='26px' height='38px' fill='white' /></> : 'Submit'
                                }
                            </Button>
                        </Box>
                    </Box>
                </Box >
            }
            {
                !isLoading && quizInProgress && quizCompleted &&
                <QuizCompletion interval={intervalId} course_id={questions?.course_id} />

            }
        </>
    )
}